import colors from "./colors";
import fonts from "./fonts";
import fontSizes from "./fontSizes";
import margins from "./margins";
import media from "./media";

export default {
  colors,
  fontSizes,
  fonts,
  margins,
  media,
};

export { default as media } from "./media";
